import { LOADING, ERROR, CLEAR_ERRORS } from '../constants/globalConstants'
import {
  FORGOT_PASSWORD,
  LOGIN,
  RESET_PASSWORD,
  SIGNUP,
  LOGOUT,
  GET_PROFILE,
  EDIT_PROFILE,
  DELETE_PROFILE,
} from '../constants/userConstants'

const userReducer = (state = {}, action) => {
  switch (action.type) {
    case CLEAR_ERRORS:
      return { ...state, loading: false, error: null, msg: null }

    case LOADING:
      return { ...state, loading: true }

    case LOGIN:
      return { ...state, loading: false, error: null, userInfo: action.payload }

    case SIGNUP:
      return { ...state, loading: false, error: null, userInfo: action.payload }

    case ERROR:
      return { ...state, loading: false, error: action.payload }

    case FORGOT_PASSWORD:
      return { ...state, loading: false, error: null, msg: action.payload }

    case RESET_PASSWORD:
      return { ...state, loading: false, error: null, msg: action.payload }

    case LOGOUT:
      return { ...state, loading: false, error: null, userInfo: null }

    case GET_PROFILE:
      return { ...state, loading: false, error: null, profile: action.payload }

    case EDIT_PROFILE:
      return { ...state, loading: false, error: null, userInfo: action.payload }

    case DELETE_PROFILE:
      return { ...state, loading: false, error: null, userInfo: null, profile: null }

    default:
      return state
  }
}

export default userReducer